import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {addLocale, locale} from "primereact/api";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

const NotificationListComponent = (props) => {
  const {t} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [places, setPlaces] = useState([]);
  const [notification, setNotification] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const filterTextMatchModes = [
    {label: t('filter_like'), value: 'like'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
  ]
  const filterNumberMatchModes = [
    {label: t('filter_between_number'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const filterDateMatchModes = [
    {label: t('filter_between_date'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('notification_first')) || 0,
    rows: Number(localStorage.getItem('notification_rows')) || rows,
    page: Number(localStorage.getItem('notification_page')) || 0,
    sortField: localStorage.getItem('notification_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('notification_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('notification_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/notification/" + localStorage.getItem('place') + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setNotification(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', notificationSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', notificationSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm  p-button-secondary"
                tooltip={t('show')}
                onClick={() => {
                }}/>
      </React.Fragment>
    );
  }

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if(Cookies.get('instanceId') && ! localStorage.getItem('place')) {
      localStorage.setItem('place', Cookies.get('instanceId'))
    }
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('notification_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('notification_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('notification_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('notification_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('notification_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('notification_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
    axios({
      method: 'post',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "login-select",
      data: {
        email: localStorage.getItem('userEmail'),
      },
      params: {},
      headers: {}
    })
      .then(response => {
        setPlaces(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [lazyParams, window.App.state.rerenderNotificationList, localStorage.getItem('place')])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6 p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('notification_list')}</h2>
        </div>
        <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
          {localStorage.getItem('notification_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('notification_filters')
                 localStorage.removeItem('notification_sortField')
                 localStorage.removeItem('notification_sortOrder')
                 localStorage.removeItem('notification_rows')
                 localStorage.removeItem('notification_page')
                 localStorage.removeItem('notification_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }
          <Dropdown  options={places}
                    className={"p-ml-2"}
                    optionLabel="system_name"
                    optionValue="system_name"
                    filter
                    id={"accommodation"}
                    emptyMessage={t('empty_message')}
                    onChange={(e) => {
                      localStorage.setItem('place', e.value)
                      window.App.forceUpdate()
                    }}
                    value={localStorage.getItem('place') || null}
          />
          <Button type="button" label={t('new_notification')} icon={"pi pi-plus"}
                  onClick={() => {
                    navigate('/notification/create')
                  }}
                  className="p-button-success p-ml-2"/>
        </div>
      </div>
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={notification} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows} emptyMessage={t('empty_message')}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
      >
        <Column className={"p-d-relative"} style={{position: 'relative', width: '1px', maxWidth: '1px'}}
                body={(rowData) => {
                  if(rowData.urgent) {
                    return (
                      <>
                          <span className={"urgent-notification"} style={{
                            position: 'absolute',
                            left: 'right',
                            top: '0',
                            height: '100%',
                          }}></span>
                      </>
                    )
                  }
                }}/>
        <Column field="title" sortable header={t('title')}></Column>
        <Column field="message" sortable header={t('message')}></Column>
        <Column field="link" sortable header={t('link')}></Column>
        <Column header={t('seen_by')} className={"p-text-right"}
                body={(rowData) => {
                    return (
                      <span>{Number(rowData.seen_by.length)} {t('user').toLowerCase()}</span>
                    )
                }}></Column>
        <Column field="created_at_snapshot" sortable header={t('created_at')}
                body={(rowData) => {
                  if (rowData.created_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(NotificationListComponent);
